import React from 'react'
import Editor from '../../../../../../../../components/common/Editor/Editor'
import { LANGUAGES } from '../../../../../../../../constants/languages'
import { Form } from 'antd'
import { useAssignmentAccess } from '../../../../../../components/access/Access'
import { AssignmentPermissions } from '../../../../../../../../constants/assignment-permissions'

const TestDatabaseDump = () => {
    const hasEditingPermission = useAssignmentAccess([AssignmentPermissions.CAN_EDIT])

    return (
        <Form.Item name='input' rules={[{ required: true, message: 'Please, enter database dump' }]}>
            <Editor
                language={LANGUAGES.SQL.value}
                title={<label>Database dump</label>}
                readOnly={!hasEditingPermission}
            />
        </Form.Item>
    )
}

export default TestDatabaseDump
